import { styled } from '@mui/material';

import CopyButton from '../../CopyButton';

export const OrderMFlexQRInfoChip = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.action.active,
  padding: theme.spacing(0, 1),
}));

export const OrderMFlexQRInfoCopyButton = styled(CopyButton)(({ theme }) => ({
  padding: 0,
  color: theme.palette.common.white,
  fontSize: theme.typography.pxToRem(14),
}));
